import { Box, Divider, useTheme } from "@mui/material";

export type SeparatorProps = {
    thickness?: number;
    color?: string;
    variant?: "fullWidth" | "inset" | "middle";
    orientation?: "horizontal" | "vertical";
    marginY?: number;
};

export const Separator = (props: SeparatorProps) => {
    const { thickness = 1, color, variant = "fullWidth", orientation = "horizontal", marginY = 2 } = props;

    const theme = useTheme();

    return (
        <Box
            sx={{
                position: "relative",
                margin: orientation === "horizontal" ? theme.spacing(marginY, 0) : theme.spacing(0, marginY),
            }}
        >
            <Divider
                orientation={orientation}
                variant={variant}
                sx={{
                    borderBottomWidth: thickness,
                    borderColor: color || "inherit",
                }}
            />
        </Box>
    );
};
